<template>
    <div class="footer">
        <footer-simple :footer="footer" v-if="true"></footer-simple>
        <footer-complex v-else></footer-complex>
    </div>
</template>

<script>
import { PaasTenant } from '@/models/paas-tenant'
import FooterSimple from '@/templates/footer/simple.vue'
import FooterComplex from '@/templates/footer/complex.vue'

export default {
    data(){
        return {
            footer: {}
        }
    },
    components: {
        FooterSimple,
        FooterComplex
    },
    created(){
        this.init()
    },
    methods: {
        init(){
            PaasTenant.getFooter().then(res => {
                this.footer = res
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/layout/footer.vue